import { createReducer, on } from '@ngrx/store';

import { RequestStatus } from '@patient-ui/shared/enums';
import { PatientEstimateVerifyResponse } from '@patient-ui/shared/models';

import { PatientEstimateActions } from './patient-estimate.actions';

export const patientEstimateFeatureKey = 'patientestimate';

export interface PatientEstimateState {
  verifyResponse: PatientEstimateVerifyResponse | null;
  verifyRequestStatus: RequestStatus;
  verifyRequestError: string;
  errorCode: string;
}

export const initialState: PatientEstimateState = {
  verifyResponse: null,
  verifyRequestStatus: RequestStatus.NotSent,
  verifyRequestError: '',
  errorCode: '',
};

export const patientEstimateReducer = createReducer(
  initialState,
  on(PatientEstimateActions.VerifyPatientEstimate, (state) => ({
    ...state,
    verifyRequestStatus: RequestStatus.Pending,
    verifyRequestError: '',
    errorCode: '',
  })),
  on(
    PatientEstimateActions.VerifyPatientEstimateSuccess,
    (state, { response }) => ({
      ...state,
      verifyResponse: response,
      verifyRequestStatus: RequestStatus.Success,
      verifyRequestError: '',
      errorCode: '',
    })
  ),
  on(
    PatientEstimateActions.VerifyPatientEstimateFailure,
    (state, { error }) => ({
      ...state,
      verifyResponse: null,
      verifyRequestStatus: RequestStatus.Failure,
      verifyRequestError: error.message,
      errorCode: error.status.toString(),
    })
  ),
  on(PatientEstimateActions.ClearPatientEstimateState, () => ({
    ...initialState,
  }))
);
